import * as actions from './Actions';

const parseUserCompany = (payload) => {
    if (!payload) return null;
    
    return {
        id: payload.id || null,
        username: payload.username || '',
        password: payload.authPassword || '',
        email: payload.email || '',
        firstName: payload?.profile?.firstName || payload?.firstName || '',
        lastName: payload?.profile?.lastName || payload?.lastName || '',
        roleId: payload.roleId || payload.role?.roleId,
        roleName: payload.role?.name,
        roleType: payload.role?.type,
        posteName: payload.Poste?.name || payload.poste?.name || '',
        role: payload.role || null,
        permissions: payload.permissions || [],
        isActivated: payload.isActivated ?? true,
        isArchived: payload.isArchived ?? false,
        createdAt: payload.createdAt || null,
        updatedAt: payload.updatedAt || null,
        companyData: payload.companyData || null,
        // Prefer canonical Poste from backend, fallback to lowercase poste
        poste: payload.Poste || payload.poste || null,
        posteId: payload.posteId || payload.Poste?.posteId || payload.poste?.posteId || null,
        posteSkillRequirements: Array.isArray(payload.Poste?.skillRequirements) ? payload.Poste.skillRequirements : [],
        // Include evaluations from API so profile dialog can display skills
        evaluations: Array.isArray(payload.evaluations) ? payload.evaluations : [],
        profile: {
            ...payload.profile,
            profilePic: payload.profile?.profilePic || null
        }
    };
};

export const employeesReducer = (state = [], action) => {
    switch (action.type) {
        case actions.INITIALIZE_EMPLOYEES:
            return action.payload.map(user => parseUserCompany(user));

        case actions.ADD_EMPLOYEE:
            return [...state, parseUserCompany(action.payload)];

        case actions.UPDATE_EMPLOYEE:
            return state.map(user =>
                user.id === action.payload.id
                    ? parseUserCompany(action.payload) 
                    : user
            );

        case actions.DELETE_EMPLOYEE:
            return state.filter(user => user.id !== action.userId);

        case actions.RESTORE_EMPLOYEE:
            return state.filter(user => user.id !== action.userId);

        case actions.ASSIGN_PERMISSIONS_TO_EMPLOYEE:
            return state.map(user =>
                user.id === action.payload.userId
                    ? { ...user, permissions: action.payload.permissions }
                    : user
            );

        case actions.CLEAR_EMPLOYEES_LIST:
            return [];

        case actions.ASSIGN_POSTE_TO_EMPLOYEE:
            return state.map(user =>
                user.id === action.payload.userId
                    ? { 
                        ...user, 
                        poste: action.payload.poste,

                        posteId: action.payload.poste?.posteId,
                        posteName: action.payload.poste?.name 

                      }
                    : user
            );

        default:
            return state;
    }
};
